import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CloudUpload from '@material-ui/icons/CloudUpload'
import Description from '@material-ui/icons/Description'
import HighlightOff from '@material-ui/icons/HighlightOff'
import {
  cyan,
  errorD1,
  errorL1,
  informationL1,
  kellyGreenD1,
  lightGray2,
  midGray,
  royalBlue,
  white,
} from 'shared/theme/colors'
import styled, { css } from 'styled-components'

import { breakpoints } from '../../theme/breakpoints'
import { centeredContent } from '../../theme/mixins'

export const DropZoneWrap = styled.div`
  width: 100%;
`

export const DropZoneContainer = styled.div<{
  $hasError?: boolean
  $dragStatus?: boolean
  $noMargin?: boolean
  $hasMultipleFileList?: boolean
  $backgroundColor?: string
}>`
  ${centeredContent};
  flex-direction: column;
  position: relative;
  font-family: Overpass, sans-serif;
  width: 100%;
  max-width: 424px;
  height: 90px;
  margin: 0 auto 4px;
  border-radius: 3px;
  padding: 20px;
  background: ${({ $hasError, $dragStatus, $backgroundColor }) =>
    $dragStatus ? informationL1 : $hasError ? errorL1 : $backgroundColor || white};
  border: 1px solid
    ${({ $hasError, $dragStatus }) => ($dragStatus ? cyan : $hasError ? errorD1 : 'transparent')};

  &:hover {
    background: ${informationL1};
    border: 1px solid ${cyan};
    cursor: pointer;
  }

  ${(p) =>
    p.$hasMultipleFileList &&
    css`
      border-radius: 0 0 3px 3px;
      height: 70px;
    `}

  ${(p) =>
    p.$noMargin &&
    css`
      margin-bottom: 0;
    `}
`

export const FileInput = styled.input.attrs({
  type: 'file',
  accept: 'image/jpg, image/png, image/gif, .pdf',
  value: '',
})`
  display: none;
`

export const UploadIcon = styled(CloudUpload)`
  color: ${royalBlue};
  margin-right: 5px;
  margin-bottom: -5px;
  font-size: 20px;
`

export const CancelFile = styled(HighlightOff)`
  color: ${lightGray2};
  margin-left: auto;
  cursor: pointer;
`

export const ApprovedFile = styled(CheckCircleOutlineIcon)`
  color: ${kellyGreenD1};
  background-color: #d1f5e8;
  margin-left: auto;
  cursor: pointer;
  border-radius: 50%;
`

export const DescriptionIcon = styled(Description)`
  color: ${midGray};
  margin-right: 12px;
`

export const OnDrop = styled.div`
  ${centeredContent};
  flex-direction: column;

  svg {
    height: 30px;
    width: 30px;
    margin-bottom: 0;
    margin-right: 0;
  }
`

export const FileNameWrapper = styled.div<{ $hasHover?: boolean }>`
  display: grid;
  align-items: center;
  max-width: 100%;
  grid-template-columns: 30px 1fr auto;
  width: 100%;

  ${(p) =>
    p.$hasHover &&
    css`
      padding: 7px 40px;
      grid-template-columns: 25px 1fr auto;

      @media ${breakpoints.xs} {
        padding: 5px 20px;
      }

      ${CancelFile} {
        opacity: 0;

        @media ${breakpoints.xs} {
          opacity: 1;
        }
      }
    `}

  &:hover {
    ${(p) =>
      p.$hasHover &&
      css`
        background: ${informationL1};

        ${CancelFile} {
          opacity: 1;
        }
      `}
  }
`

export const FileName = styled.div`
  max-width: 290px;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 20px;
  white-space: nowrap;
`

export const ErrorMessage = styled.div`
  color: ${errorD1};
  height: 18px;
  font-size: 12px;
  width: 100%;
  max-width: 424px;
  margin: 0 auto 2px;
`

export const FilesList = styled.div`
  width: 100%;
  max-width: 424px;
  margin: 0 auto 2px;
  border-radius: 3px 3px 0 0;
  padding: 15px 0;
  background: white;
  max-height: 170px;
  overflow-y: auto;
`
